module.exports = __webpack_public_path__ + "img/h2s.9d86122e.svg";